import styled from "styled-components";
import CachedIcon from "@mui/icons-material/Cached";
import { theme } from "helpers/constants";
import { Column } from "helpers/generalStyles";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";

export const Container = styled.div`
  border: 1px solid #b2b2b2;
  border-radius: 8px;
  background: #fdfdfd;
  padding: 25px;
  margin: 20px;
`;
export const GenerateIcon = styled(CachedIcon)`
  color: white;
  background-color: ${theme.color.primary};
  padding: 2px;
  border-radius: 50%;
  font-size: 20px;
  cursor: pointer;
`;

export const DiscountListContainer = styled(Column)`
  max-height: 70vh;
  overflow: auto;
  border: 1px solid #b2b2b2;
  border-radius: 8px;
  background: #fdfdfd;
  padding: 25px;
  width: 350px;
  margin: 20px;
`;

export const DiscountCardContainer = styled(Column)`
  position: relative;
  width: 100%;
`;

export const DiscountNameContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
`;

export const EndTextStatus = styled.p`
  padding: 5px;
  border-radius: 5px;
  font-size: 12px;
  margin: 0;
  background-color: #F4B4A4;
  border: 2px solid #8E1F15;
`;

export const DeleteIcon = styled(DeleteForeverIcon)`
  color: #f73131;
  position: absolute;
  right: 8px;
  top: 8px;
  cursor: pointer;
`;

export const DiscountDiv = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  width: 100%;
`;

export const InputContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 5px;
  width: 100%;
`;

export const InputNumberContainer = styled.div`
  display: flex;
  flex: 1
`;
export const InputSelectContainer = styled.div`
  display: flex;
  flex: 2
`;
